const RESERVED_BOOX_APP_LABELS = new Set([
  'app',
  'auth',
  'share',
  'cc',
  'go',
  'hub',
  'www',
]);

function normalizeHost(host?: string): string {
  return (host ?? '').trim().toLowerCase();
}

export function getCurrentHost(): string {
  if (typeof window === 'undefined') return '';
  return normalizeHost(window.location.hostname);
}

export function isReservedBooxAppHost(host = getCurrentHost()): boolean {
  const normalizedHost = normalizeHost(host);
  if (!normalizedHost.endsWith('.boox.app')) return false;
  const label = normalizedHost.split('.')[0] ?? '';
  return RESERVED_BOOX_APP_LABELS.has(label);
}

export function isTenantAppHost(host = getCurrentHost()): boolean {
  const normalizedHost = normalizeHost(host);
  return normalizedHost.endsWith('.boox.app') && !isReservedBooxAppHost(normalizedHost);
}

export function isTenantNetworkHost(host = getCurrentHost()): boolean {
  return normalizeHost(host).endsWith('.boox.network');
}

export function isBooxPlatformHost(host = getCurrentHost()): boolean {
  const normalizedHost = normalizeHost(host);
  return normalizedHost.endsWith('.boox.app') || normalizedHost.endsWith('.boox.network');
}

export function getPlatformApiOrigin(host = getCurrentHost()): string {
  if (isBooxPlatformHost(host)) return 'https://hub.boox.app';
  return '';
}
